import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Dashboard from './Dashboard';
import InformationPortal from './InformationPortal';
import ErrorBoundary from './ErrorBoundary';
import LegalFooter from './LegalFooter';
import TeamMessengerWidget from './TeamMessengerWidget';
import PrivacyPolicyPage from './PrivacyPolicyPage';

export default function App() {
    const [search, setSearch] = useState(() => window.location.search || '');
    const [authState, setAuthState] = useState({ isAuthenticated: false, authResolved: false });
    const handleAuthChange = useCallback((next) => {
        if (next && typeof next === 'object') {
            setAuthState({
                isAuthenticated: Boolean(next.isAuthenticated),
                authResolved: Boolean(next.authResolved)
            });
            return;
        }

        setAuthState({ isAuthenticated: Boolean(next), authResolved: true });
    }, []);

    useEffect(() => {
        const onPopState = () => setSearch(window.location.search || '');
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    const { portal, isPrivacyPage } = useMemo(() => {
        const params = new URLSearchParams(search || '');
        return {
            portal: (params.get('portal') || '').toLowerCase(),
            isPrivacyPage: (params.get('view') || '').toLowerCase() === 'privacy'
        };
    }, [search]);

    if (isPrivacyPage) {
        return (
            <ErrorBoundary>
                <div className="app-shell">
                    <div className="app-shell__content">
                        <PrivacyPolicyPage />
                    </div>
                    <LegalFooter />
                </div>
            </ErrorBoundary>
        );
    }

    if (portal === 'developer' || portal === 'surveyor' || portal === 'funder') {
        return (
            <ErrorBoundary>
                <div className="app-shell">
                    <div className="app-shell__content">
                        <InformationPortal mode={portal} />
                    </div>
                    <LegalFooter />
                </div>
            </ErrorBoundary>
        );
    }

    return (
        <ErrorBoundary>
            <div className="app-shell">
                <div className="app-shell__content">
                    <Dashboard onAuthChange={handleAuthChange} />
                    {authState.authResolved && authState.isAuthenticated ? <TeamMessengerWidget /> : null}
                </div>
                <LegalFooter />
            </div>
        </ErrorBoundary>
    );
}
